<template>
  <div class="container">
    <div class="searchPlace">
      <GmapAutocomplete class="input"
        :selectFirstOnEnter="true"
        @place_changed="searchPlace" />
    </div>
    <Map
      :locale="locale"
      :from="hotelGeo"
      :search="search"
      @preview="previewLocalInfo" />
    <Preview
      v-if="location && location !== null"
      :locale="locale"
      :from="hotelGeo"
      :location="location"
      @close="closePreview" />
  </div>
</template>

<script>
import Map from '@/components/LocalInfo/LocalInfoMap.vue'
import Preview from '@/components/LocalInfo/LocalInfoPreview.vue'

export default {
  name: 'LocalInfoCreate',
  props: [
    'locale'
  ],
  components: {
    Map,
    Preview
  },
  computed: {
    hotelGeo () {
      return this.$store.state.localinfo.hotelGeo
    }
  },
  mounted () {
  },
  data () {
    return {
      search: null,
      preview: false,
      location: null
    }
  },
  methods: {
    searchPlace (data) {
      this.search = {
        placeId: data.place_id,
        name: data.name,
        address: data.formatted_address,
        icon: data.icon,
        lat: data.geometry.location.lat(),
        lng: data.geometry.location.lng()
      }
    },
    previewLocalInfo (data) {
      this.preview = true
      this.location = Object.assign({}, data)
    },
    closePreview (res) {
      this.preview = false
      this.location = null
      this.search = null
      const input = document.querySelector('.searchPlace input')
      input.value = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.searchPlace {
  position: absolute;
  top: 40px;
  left: 240px;
  right: 240px;
  z-index: 999;
  .input {
    height: 40px;
    border: none;
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
  }
}
</style>
